import { api } from "./api";

import { ISearchparams } from "@/shared/interfaces/patientPage";

export async function getAllUsers(
    limit?: number,
    page?: number,
    sort?: string,
) {
    const params: ISearchparams = {};
    if (page) params.page = page;
    if (limit) params.limit = limit;
    if (sort) params.sort = sort;

    const queryString = new URLSearchParams(
        Object.entries(params).reduce((acc, [key, value]) => {
            if (value !== undefined) acc[key] = String(value);
            return acc;
        }, {} as Record<string, string>),
    ).toString();
    try {
        const response = await api.get(`users?${queryString}`, {
            withCredentials: true,
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        return { error: (error as Error).message };
    }
}
